export { default } from './List';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/List/index.js
// module id = 324
// module chunks = 2